import { ASSETS } from './assets-data'

const warrantyData = {
  en: {
    seo: {
      title: 'Warranty | BH Hardware',
      description: 'BH Hardware 5-year extended warranty on garage door springs — what\'s covered, what\'s not, and how to file a warranty claim.',
      keywords: 'BH Hardware warranty, garage door spring warranty, 5-year warranty, torsion spring warranty, bhhardware.net'
    },
    heroSection: {
      image: "/placeholder.svg",
      overlay: "bg-black/60"
    },
    title: 'Warranty',
    effectiveDateLabel: 'Last Updated',
    effectiveDate: 'October 1, 2025',

    introParagraphs: [
      'At BH Hardware, we are dedicated to providing you with high-quality products that you can rely on. To give you peace of mind, we offer a 5-Year Extended Warranty on our garage door springs, including torsion springs, commercial springs, and extension springs.',
      'This warranty covers the replacement of parts for up to 5 years from the date of purchase, ensuring that your garage door springs continue to perform at their best.'
    ],

    sections: [
      {
        id: 'covered',
        number: 1,
        heading: "What's Covered",
        paragraphs: [
          'Our 5-year extended warranty covers the replacement of parts for the following types of springs:',
          'Torsion Springs.',
          'Commercial Springs.',
          'Extension Springs.',
          'This warranty is valid for 5 years from the original purchase date and applies to defects in materials or workmanship under normal use. If your springs fail due to such issues, we will replace the defective parts at no cost to you.'
        ]
      },
      {
        id: 'not-covered',
        number: 2,
        heading: "What's Not Covered",
        paragraphs: [
          'While we stand by the quality of our products, the following are not covered under our 5-year warranty:',
          'External damage to the garage door: Any damage to the garage door, door components, or surrounding structure caused by any external factors. Always ensure professional installation is applied.',
          'Improper installation: If the springs are not installed by a certified professional or installation is done incorrectly, the warranty will be void.',
          'Misuse or abuse: Damage resulting from misuse, neglect, or abnormal wear is not covered.',
          'Acts of nature: Damage caused by extreme weather events or accidents (such as storms, floods, etc.) is not covered.'
        ]
      },
      {
        id: 'shipping-costs',
        number: 3,
        heading: 'Shipping Costs',
        paragraphs: [
          'Please note that shipping costs are the responsibility of the customer when a replacement needs to be sent out. Shipping costs will be invoiced to you and must be paid before any replacement parts are shipped.'
        ]
      },
      {
        id: 'how-to-claim',
        number: 4,
        heading: 'How to Claim Your Warranty',
        paragraphs: [
          'If your garage door springs fail and are covered under this warranty, please follow these steps:',
          '1. Contact Us — Reach out to our customer service team by emailing admin@bh-hardware.net.',
          '2. Provide Proof of Purchase — To verify the warranty, we will need a copy of your proof of purchase showing the original purchase date.',
          '3. Inspection and Approval — Our team will assess the issue and determine if it is covered under the warranty. If approved, we will provide instructions for replacing the defective parts.',
          '4. Shipping — If the warranty claim is approved, the customer will be responsible for covering the cost of shipping. We will then send the replacement parts at no additional cost.'
        ]
      }
    ],

    contactTitle: 'Warranty Claims & Questions',
    contactIntro: 'To start a warranty claim or ask a question, email us at admin@bh-hardware.net or call +1 855-786-7504.',

    conversionSection: {
      title: '5-Year Peace of Mind',
      subtitle: 'We stand behind every spring we sell. Our warranty is our commitment to quality and your long-term satisfaction.',
      bgImage: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/backgrounds/warehouse_bg.jpg",
      bgColor: "bg-gray-50 dark:bg-zinc-900",
      buttonText: 'Return Home'
    }
  },

  he: {
    seo: {
      title: 'אחריות | BH Hardware',
      description: 'אחריות מורחבת של 5 שנים מ-BH Hardware על קפיצי דלת מוסך — מה מכוסה, מה לא ואיך להגיש תביעת אחריות.',
      keywords: 'אחריות BH Hardware, קפיץ דלת מוסך, 5 שנות אחריות, bhhardware.net'
    },
    heroSection: {
      image: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/backgrounds/warehouse_bg.jpg",
      overlay: "bg-black/60"
    },
    title: 'אחריות',
    effectiveDateLabel: 'עודכן לאחרונה',
    effectiveDate: '1 באוקטובר 2025',

    introParagraphs: [
      'ב-BH Hardware, אנו מחויבים לספק לכם מוצרים באיכות גבוהה עליהם אפשר לסמוך. לשקט נפשי שלכם, אנו מציעים אחריות מורחבת של 5 שנים על קפיצי דלתות מוסך שלנו.',
      'אחריות זו מכסה החלפת חלקים עד 5 שנים ממועד הרכישה, ומבטיחה שהקפיצים שלכם ימשיכו לפעול במיטבם.'
    ],

    sections: [
      {
        id: 'covered',
        number: 1,
        heading: 'מה מכוסה',
        paragraphs: [
          'האחריות המורחבת של 5 שנים מכסה החלפת חלקים עבור סוגי הקפיצים הבאים:',
          'קפיצי תלייה (Torsion Springs).',
          'קפיצים מסחריים (Commercial Springs).',
          'קפיצי הרחבה (Extension Springs).',
          'האחריות בתוקף ל-5 שנים ממועד הרכישה המקורי ומחילה על פגמים בחומרים או בעבודה בשימוש רגיל.'
        ]
      },
      {
        id: 'not-covered',
        number: 2,
        heading: 'מה לא מכוסה',
        paragraphs: [
          'הדברים הבאים אינם מכוסים תחת האחריות שלנו:',
          'נזק חיצוני לדלת המוסך: כל נזק לדלת, לרכיביה או למבנה הסובב שנגרם מגורמים חיצוניים. תמיד ודאו שמתבצעת התקנה מקצועית.',
          'התקנה שגויה: אם הקפיצים לא הותקנו על ידי מקצוען מוסמך, האחריות תתבטל.',
          'שימוש לרעה או הזנחה: נזק הנגרם משימוש לרעה, הזנחה או בלאי חריג אינו מכוסה.',
          'כוח עליון: נזק הנגרם מאירועי מזג אוויר קיצוניים או תאונות אינו מכוסה.'
        ]
      },
      {
        id: 'shipping-costs',
        number: 3,
        heading: 'עלויות משלוח',
        paragraphs: [
          'עלויות משלוח ההחלפה הן באחריות הלקוח. עלויות המשלוח ייחויבו לפני שיישלחו חלקי החלפה.'
        ]
      },
      {
        id: 'how-to-claim',
        number: 4,
        heading: 'כיצד להגיש תביעת אחריות',
        paragraphs: [
          'אם קפיצי דלת המוסך שלכם נכשלו וכלולים תחת אחריות זו, אנא פעלו לפי השלבים הבאים:',
          '1. צרו קשר — שלחו אימייל ל-admin@bh-hardware.net.',
          '2. הגישו הוכחת רכישה — נדרש עותק של הוכחת הרכישה עם תאריך הרכישה המקורי.',
          '3. בדיקה ואישור — הצוות שלנו יבחן את הבעיה ויקבע אם היא מכוסה.',
          '4. משלוח — אם תביעת האחריות אושרה, הלקוח יהיה אחראי לעלויות המשלוח. חלקי ההחלפה יישלחו ללא עלות נוספת.'
        ]
      }
    ],

    contactTitle: 'תביעות אחריות ושאלות',
    contactIntro: 'לפתיחת תביעת אחריות או שאלה, שלחו אימייל ל-admin@bh-hardware.net או התקשרו ל-+1 855-786-7504.',

    conversionSection: {
      title: '5 שנות שקט נפשי',
      subtitle: 'אנו עומדים מאחורי כל קפיץ שאנו מוכרים. האחריות שלנו היא המחויבות שלנו לאיכות ולשביעות רצון ארוכת טווח.',
      bgImage: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/backgrounds/warehouse_bg.jpg",
      bgColor: "bg-gray-50 dark:bg-zinc-900",
      buttonText: 'חזרה לדף הבית'
    }
  }
};

export function getWarrantyStrings(language) {
  return warrantyData[language] || warrantyData.en;
}

export default warrantyData;
